import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  InputHTMLAttributes,
} from 'react';

import { useField } from '@unform/core';
import Checkbox from '../../../../components/Exame/CheckBox';
import { Container, ContentPrincipal, ContentTitle } from './styles';
import getResponseErrors from '../../../../utils/getResponseErrors';
import { useToast } from '../../../../hooks/toast';
import { arrayGroupBy } from '../../../../utils/funcoes';
import Loading from '../../../../components/Loading';
import SelectSync, { IOption } from '../../../../components/SelectSync';
import { useGrupoExame } from '../../../../hooks/grupoExames';

interface ICheck {
  name: string;
  key: string;
  label: string;
  checked?: boolean;
}

interface DivProps extends InputHTMLAttributes<HTMLDivElement> {
  name: string;
  gexCodigo?: number;
}

export interface IProcedimentos {
  ProCodigo: number;
  ProNome: string;
  perfil: {
    PerCodigo: number;
    PerNome: string;
  };
}

interface IOptions {
  value: string;
  label: string;
  isDisabled?: boolean;
}

const CheckboxContainer: React.FC<DivProps> = ({
  name,
  gexCodigo,
  ...rest
}) => {
  const { grupos } = useGrupoExame();
  const checkRef = useRef(null);
  const { fieldName, defaultValue, registerField } = useField(name);
  const [checkedItems, setCheckedItems] = useState<string>('');
  const [itens, setItens] = useState<{ perfil: string; itens: ICheck[] }[]>([]);
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [procedimentos, setProcedimentos] = useState<
    IProcedimentos[] | undefined
  >(undefined);

  const [optionsGrupo, setOptionsGrupo] = useState<IOptions[]>([]);
  const [grupoPadrao, setGrupoPadrao] = useState<IOptions>({
    value: '',
    label: '',
  });

  /* constructor(props) {      super(props);      this.state = {         checkedItems: new Map(),      };
      this.handleChange = this.handleChange.bind(this);   } */
  // useEffect(() => {
  //   async function loadGrupos(): Promise<void> {
  //     setLoading(true);
  //     try {
  //       const response = await api.get<[grupos: IGrupo[], total: number]>(
  //         `/grupoexames`,
  //       );
  //       const [grps, total] = response.data;
  //       setGrupos(undefined);
  //       setGrupos(grps);
  //     } catch (error) {
  //       const mensagemErro = getResponseErrors(error);
  //       addToast({
  //         title: 'Não foi possível buscar dados',
  //         type: 'error',
  //         description: mensagemErro,
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }

  //   loadGrupos();
  // }, [defaultValue, addToast]);

  useEffect(() => {
    if (grupos) {
      let padrao = {
        value: '',
        label: '',
      };
      const options: IOptions[] = grupos.grupos.map(grp => {
        if (grp.GexNome === 'Padrão')
          padrao = {
            label: grp.GexNome,
            value: grp.GexCodigo ? grp.GexCodigo.toString() : '0',
          };
        return {
          label: grp.GexNome,
          value: grp.GexCodigo ? grp.GexCodigo.toString() : '0',
        };
      });
      setOptionsGrupo(options);
      setGrupoPadrao(padrao);
    }
  }, [grupos]);

  const carregaProcedimentos = useCallback(
    (GexCodigo: number) => {
      setLoading(true);
      try {
        setItens([]);
        setProcedimentos(undefined);
        const grupoSelecionado = grupos.grupos?.find(
          grp => grp.GexCodigo === GexCodigo,
        );
        const procs: IProcedimentos[] | undefined = grupoSelecionado?.itens.map(
          it => {
            return {
              ProCodigo: it.procedimento?.ProCodigo || 0,
              ProNome: it.procedimento?.ProNome || '',
              perfil: {
                PerCodigo: Number(it.procedimento?.perfil?.PerCodigo || '0'),
                PerNome: it.procedimento?.perfil?.PerNome || '',
              },
            };
          },
        );
        setProcedimentos(procs);
        if (procs) {
          const procedimentoAgupados = arrayGroupBy(
            procs,
            (i: IProcedimentos) => i.perfil.PerCodigo,
          );

          const procedimentoPerfil = procedimentoAgupados.map(it => {
            return {
              perfil: it[0].perfil.PerNome,
              itens: it.map(proc => {
                return {
                  name: `${proc.ProCodigo}-${proc.ProNome}`,
                  label: `${proc.ProNome}`,
                  key: `${proc.ProCodigo}`,
                  checked: grupoSelecionado?.GexSelecionado
                    ? true
                    : defaultValue.split(',').indexOf(proc.ProCodigo) !== -1,
                };
              }),
            };
          });
          setItens(procedimentoPerfil);

          const its = procedimentoPerfil.map(it => {
            return it.itens
              .filter(item => {
                return item.checked;
              })
              .map(i => i.key)
              .join(',');
          });

          setCheckedItems(its.join(','));
        }
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar dados',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [defaultValue, addToast, grupos],
  );

  useEffect(() => {
    if (gexCodigo) carregaProcedimentos(gexCodigo);
  }, [gexCodigo, carregaProcedimentos]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: checkRef.current,
      path: 'value',
      clearValue: ref => {
        ref.clear();
      },
      setValue: (ref, valord) => {
        // setCheckedItems(valord);
      },
    });
  }, [checkedItems, fieldName, registerField, itens]);

  const handleChange = useCallback(
    e => {
      const nomeProcedimento = e.target.name;
      const isChecked = e.target.checked;

      const newItens = itens.map(it => {
        const procs = it.itens.map(item => {
          if (item.name === nomeProcedimento)
            return { ...item, checked: isChecked };
          return item;
        });
        return { perfil: it.perfil, itens: procs };
      });

      const its = newItens.map(it => {
        return it.itens
          .filter(item => {
            return item.checked;
          })
          .map(i => i.key)
          .join(',');
      });

      setCheckedItems(its.join(','));

      setItens(newItens);
    },
    [itens],
  );

  const handleSelectChange = useCallback(
    (dados: IOption) => {
      carregaProcedimentos(Number(dados.value));
    },
    [carregaProcedimentos],
  );

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      {grupoPadrao && optionsGrupo && gexCodigo === undefined && (
        <SelectSync
          handleSelectChange={handleSelectChange}
          name="grupo"
          label="Grupo de Exames"
          placeholder="Selecione um Grupo para exibir os Exames"
          options={optionsGrupo}
        />
      )}
      {itens.map(it => (
        <div key={`perfil-${it.perfil}`}>
          <ContentTitle>
            <h2>{it.perfil}</h2>
          </ContentTitle>

          <ContentPrincipal>
            <input
              className="d-none"
              value={checkedItems}
              onChange={() => console.log(itens)}
              ref={checkRef}
            />
            {it.itens.map(item => (
              <Container
                key={`ch-${it.perfil}${item.key}${
                  Math.random() * 999999999999
                }`}
              >
                <Checkbox
                  name={item.name}
                  checked={item.checked}
                  onChange={handleChange}
                />
                <label htmlFor={item.name}>{item.label}</label>
              </Container>
            ))}
          </ContentPrincipal>
        </div>
      ))}
    </>
  );
};

export default CheckboxContainer;
